import {Badge, Button, Flex, Heading, Note, TextLink} from "@contentful/f36-components";
import {ExternalLinkIcon} from "@contentful/f36-icons";
import React from "react";
import {getVariantFromStatus} from "../../utils";
import {cancelOrders} from "../../services/translated";
import {useSDK} from "@contentful/react-apps-toolkit";
import '../Order.css';

export const OrderDetail = ({ order }) => {
    const sdk = useSDK();

    const cancelOrder = async () => {
        try {
            const undeletedOrders = await cancelOrders({
                apiKey: sdk.parameters.installation.apiKey,
                orders: order.id_requests,
            });
            if (undeletedOrders.orders.length > 0) {
                sdk.notifier.warning('Warning: not all orders could be deleted!');
            } else {
                sdk.notifier.success('Order cancelled successfully.');
            }
        } catch (e) {
            sdk.notifier.error(e.response?.data ?? e.message);
        }
    }

    const linkDashboard = `${process.env.REACT_APP_TOS_DASHBOARD_BASE_URL}/requests?search=${order.idOrderGroup}`;

    return (
        <div className="p-24">
            <Note variant="neutral" className="mb-24">
                Only "In queue" orders can be canceled.
            </Note>
            <Flex alignItems="start">
                <Heading className="mr-10">Order Group ID: {order.idOrderGroup}</Heading>
                <TextLink
                    icon={<ExternalLinkIcon/>}
                    href={linkDashboard}
                    target="_blank"/>
            </Flex>
            <Badge className="mb-24" variant={getVariantFromStatus(order.status)}>{order.status}</Badge>
            <Flex justifyContent={"space-between"}>
                <Flex flexDirection="column">
                    <strong>Order date</strong>
                    <span>{order.orderDate}</span>
                </Flex>
                <Flex flexDirection="column">
                    <strong>Due date</strong>
                    <span>{order.dueDate}</span>
                </Flex>
                <Flex flexDirection="column">
                    <strong>Service type</strong>
                    <span>{order.serviceType}</span>
                </Flex>
            </Flex>
            <Flex className="mt-16" flexDirection="column">
                <strong>Source language</strong>
                <span>{order.sourceLanguage}</span>
            </Flex>
            <Flex className="mt-16 mb-16" flexDirection="column">
                <strong>Target languages ({order.numberOfLanguages})</strong>
                <span>{order.targetLanguages.join(', ')}</span>
            </Flex>
            <hr />
            <Flex className="mt-16 mb-16" flexDirection="column">
                <strong>Contents:</strong>
                {order.contents.map((c) => {
                    return (<span key={c}>{c}</span>)}
                )}
            </Flex>
            <Flex className="mt-16 mb-16" justifyContent={"end"}>
                <Button className="mr-8" variant="secondary" onClick={() => window.open(`mailto:${process.env.REACT_APP_EMAIL_ADDRESS}`)}>Contact us</Button>
                {order.status === 'IN QUEUE' && <Button variant="negative" onClick={() => cancelOrder()}>Cancel order</Button>}
            </Flex>
        </div>
    )
}